import React from "react";

//firebase
import { db } from 'assets/firebase';

//router
import { Redirect } from "react-router-dom";

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CartCleared, CartProductRemoved } from 'redux/actions';

// order
import { orders } from 'assets/orders';

//stripe
import {Elements, StripeProvider} from 'react-stripe-elements';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import shoppingCartStyle from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.jsx";
import classNames from "classnames";

//components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Footer from "components/Footer/Footer.jsx";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import IconButton from "@material-ui/core/IconButton";
import Checkout from "components/Checkout/Checkout.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Parallax from "components/Parallax/Parallax.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Remove from "@material-ui/icons/RemoveShoppingCart";
import Receipt from "@material-ui/icons/Receipt";
import Notes from "@material-ui/icons/SpeakerNotes";



class ShoppingCartPage extends React.Component {
  constructor(props) {
    super(props);

    this.qtyChange = this.qtyChange.bind(this);
    this.notesChange = this.notesChange.bind(this);
    this.poNumberChange = this.poNumberChange.bind(this);
    this.calculateTax = this.calculateTax.bind(this);
    this.calculateTotal = this.calculateTotal.bind(this);
    this.createQuote = this.createQuote.bind(this);
    this.sendConfirmation = this.sendConfirmation.bind(this);
    
    this.state = {
      products: [],
      visibleProducts: [],
      manufacturers: [],
      tax: 0.00,
      taxDocument: {},
      shipTo: "",
      shipToAddress: { },
      notes: "",
      poNumber: "",
      completed: false,
      customer:{}
    };

    if(props.cart)
      this.state.cart = props.cart;
    else
      this.state.cart = [];

    if(this.props.user.schoolID) {
      db.getSchool(this.props.user.schoolID).then((school) => {
        console.log(school)

        this.setState({shipToAddress: {
          name: school.Name,
          address: school.Address,
          city: school.City,
          state: school.State,
          zip: school.PostalCode
        }}, () => {
          this.calculateTax();
        });
      });
    } 
    console.log(this.props)
  }
  
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  qtyBlur(product, value) {
    if(value === 0) {
      this.removeFromCart(product);
    }
  }

  qtyChange(product, value) { 
    var cart = this.state.cart;
    for(var i = 0; i < cart.length; i++) {
      if(product.id === cart[i].id) {
        cart[i].qty = value;
        break;
      }
    }
    this.setState({cart: cart}, this.calculateTax);
  }

  notesChange(e) {
    
    this.setState({notes: e.target.value});
  }

  poNumberChange(e) {
    
    this.setState({poNumber: e.target.value});
  }

  removeFromCart(product) {

    this.props.onCartProductRemoved(product);

    var cart = this.state.cart;

    for(var i = 0; i < cart.length; i++) {
      if(product.id === cart[i].id) {
        cart.splice(i, 1);
        break;
      }
    }
    
    this.setState({cart: cart}, () => {
      this.calculateTax();
    });
  }

  calculateTax() {
    this.setState({tax: 0.00}, this.calculateTotal);
    /*
    console.log("calculateTax()");

    if(!this.props.taxExempt) {
      
      console.log("customer is not exempt");
      
      var today = new Date();
      var dateString = today.getFullYear() + "-" + Number(Number(today.getMonth()) + 1) + "-" + today.getDate();

      var lines = [];
      var cart = this.state.cart;
      for(var i = 0; i < cart.length; i++) {
        
        if(this.state.exemptions) {
          for(var j = 0; j < this.state.exemptions.length; j++) {
            if(cart[i].id === this.state.exemptions[j].productID) {
              cart[i].isExempt = true;
              break;
            }
          }
        }
        
        if(!cart[i].isExempt) {
          var amount = Number(cart[i].qty) * Number(cart[i].listPrice).toFixed(2);
          lines.push({ quantity: Number(cart[i].qty), amount: amount, itemCode: cart[i].productID });
        }
      }
      
      this.setState({cart:cart}, () => {
        
      }); // so as to capture isExempt settings for items

      var customerCode = this.props.user.id;
      if(this.props.user.companyName)
        customerCode = this.props.user.companyName;
      else {
        console.log('NO COMPANY NAME')
        console.log('user props:')
        console.log(this.props.user)
      }
        
      if(lines.length === 0) { // i.e. if nothing is taxable skip Avalara
        this.setState({tax: 0.00}, this.calculateTotal);
      } else {

        const taxDocument = {
          type: 'SalesOrder',
          companyCode: 'ECCLESIAMANAGEMENTLLC',// KEKAHA
          date: dateString,
          customerCode: customerCode,
          addresses: {
            ShipFrom: {
              line1: '4100 Eldorado Pkwy',
              city: 'Mckinney',
              region: 'TX',
              country: 'US',
              postalCode: '75070-6102'
            },
            ShipTo: {
              line1: this.state.shipToAddress.address,
              city: this.state.shipToAddress.city,
              region: this.state.shipToAddress.state,
              country: this.state.shipToAddress.country,
              postalCode: this.state.shipToAddress.zip
            }
          },
          lines: lines,
          commit: false,
          currencyCode: 'USD',
          description: 'Janitorial Supplies'
        }

        this.setState({taxDocument: taxDocument});

        fetch("https://us-central1-kekaha-ebf1f.cloudfunctions.net/calculateTax", {
          method: "POST", 
          cache: "no-cache",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(taxDocument)
        })
        .then((response) => {
            
            if(response.ok) {
                return response.json();
            } else {
              console.log("error (1): ");  
              console.log(response);
            }
        })
        .then((json) => {
        
          this.setState({tax: Number(json.totalTax).toFixed(2)}, this.calculateTotal);
          
        })
        .catch((error) => {
            // If there is any error you will catch them here
            console.log("error (2):  " + error);
        });
      }

    } else {
      console.log("customer is tax-exempt");
      this.setState({tax: 0.00}, this.calculateTotal);
    }
    */
  }

  calculateTotal() {

    var cart = this.state.cart;

    var total = 0.0;
    for(var i = 0; i < cart.length; i++) {
      cart[i].total = Number(Number(cart[i].listPrice) * Number(cart[i].qty)).toFixed(2);
      total = total + Number(cart[i].total);
    }
      
    //if(this.state.tax) 
      //total = Number(total) + Number(this.state.tax);

    total = Number(total).toFixed(2);
    
    this.setState({cart: cart, total: total});
  }

  createQuote() {
    var order = {};
    
    order.notes = this.state.notes;
    order.status = 'QUOTE';
    order.userID = this.props.user.id;
    order.userName = this.props.user.firstName + " " + this.props.user.lastName;
    order.schoolName = this.state.shipToAddress.name;
    order.schoolID = this.props.user.schoolID;
    order.created = Math.round((new Date()).getTime() / 1000);
    order.modified = Math.round((new Date()).getTime() / 1000);

    order.items = this.state.cart;
    // cleanup the records a bit
    for(var i = 0; i < order.items.length; i++) {
      delete order.items[i]._highlightResult;
      delete order.items[i].attachments;
      delete order.items[i].Content;
      delete order.items[i].photo;
      delete order.items[i].thumbnail;
    }
    order.orderTotal = this.state.total;
    

    console.log(order);

    this.setState({order: order}, () => {
      db.updateOrder(order.id, order).then(() => {
        this.sendConfirmation(order, () => {
          orders.getPDF(order);
          this.props.onCartCleared();
          this.setState({completed: true});
        })
      });
    })
  }

  sendConfirmation(order, callback) {
    
    var html = '<html>';
    html = html + 'This is a summary of the estimate prepared for ' + this.state.shipToAddress.name + '. A PDF version of this estimate is also available via our website.';
    
    html = html + '<br /><br />';
    html = html + '<b>Shipping Address</b><br />';
    if(this.state.shipToAddress.name)
      if(this.state.shipToAddress.name.length > 0)
        html = html + this.state.shipToAddress.name + "<br />";
    html = html + this.state.shipToAddress.address + "<br />";
    html = html + this.state.shipToAddress.city + ", " + this.state.shipToAddress.state + " " + this.state.shipToAddress.zip + "<br />";

    html = html + '<br />';

    html = html + '<table style="width:100%" cellpadding="6">';
    html = html + '<tr>';
    html = html + '<td><b>QTY</b></td>';  
    html = html + '<td><b>SKU</b></td>';  
    html = html + '<td><b>Name</b></td>';  
    html = html + '<td><b>Price</b></td>';
    html = html + '<td><b>Total</b></td>';  
    html = html + '</tr>';

    
    for(var i = 0; i < order.items.length; i++) {
      html = html + '<tr>';
      html = html + '<td>' + order.items[i].qty + '</td>';  
      html = html + '<td>' + order.items[i].sku + '</td>'; 
      html = html + '<td>' + order.items[i].name + '</td>';  
      html = html + '<td>$' + order.items[i].listPrice + '</td>';  
      html = html + '<td>$' + order.items[i].total + '</td>';  
      html = html + '</tr>';
    }
    html = html + '</table>';

    html = html + '<br />';
    html = html + '<div style="fontWeight:600;">Order Total: ' + order.orderTotal + '</div>';  
    html = html + '<br />';
    html = html + 'When your estimate is approved and you have a PO number, click <a href="https://app.allthingseq.com/orders">here</a> to finalize your order.';
    html = html + '';
    html = html + '</html>';
    
    // admin Email
    
    const adminEmail = {
      email: this.props.user.email,//'michael@allThingsEQ.com',
      subject: 'Order Confirmation: ' + this.state.shipToAddress.name,
      body: html
    }

    fetch("https://us-central1-keiki-262db.cloudfunctions.net/sendEmail", {
        method: "POST", 
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(adminEmail)
      })
      .then((response) => {
          
          if(response.ok) {
              return response.json();
          } else {
            console.log("error (1): ");  
            console.log(response);
          }

          callback();
      })
      .catch((error) => {
          // If there is any error you will catch them here
          console.log("error (2):  " + error);
          callback();
      });
  }


  compareLabel(a,b) {

    var aName = a.label;
    var bName = b.label;
    
    if (aName < bName)
        return -1;
    if (aName > bName)
        return 1;
    return 0;
  }

  readyToCheckout() {
    if(this.state.poNumber.length > 0 && this.state.cart.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  trim(value, maxLength) {
    if(value) {
        if(value.trim().length > maxLength)
            return value.trim().substring(0,maxLength) + "...";
        else
            return value.trim();
    } else return "";
  }

  render() {
    const { classes } = this.props;

    if (this.state.completed === true) {
      return <Redirect to='/insights' />
    }

    return (
      <StripeProvider apiKey="pk_test_RhQ4N71Laf00l7nFxTeqvFOT">
      <div>
        <Header
          brand="All Things EQ"
          links={<HeaderLinks dropdownHoverColor="info" />}
          fixed
          color="transparent"
          changeColorOnScroll={{
            height: 300,
            color: "dark"
          }}
        />
        <Parallax
          image={require("assets/img/shoppingCart.jpg")}
          filter="dark"
          small
        >
          
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)} style={{backgroundColor:"#efefef"}}>
        <div className={classes.container} style={{minHeight:"369px", marginTop:"-100px"}}>
          <GridContainer style={{paddingTop:"40px"}}>
            <GridItem xs={12}>
                <h3 className={classes.cardTitle}>Shopping Cart</h3>
            </GridItem>
            <GridItem xs={12}>
              <Card >
                <CardBody>
                  <Table>
                    <TableBody>
                      {this.state.cart.map((product,index) => (
                        <TableRow key={index}>
                          <TableCell><img src={product.thumbnail} style={{ height:"89px", paddingTop:"10px", paddingBottom:"10px" }} alt="thumbnail"></img></TableCell>
                          <TableCell>
                            <b>{this.trim(product.name,123)}</b><br />
                            {this.trim(product.description,123)}<br />
                          </TableCell>
                          <TableCell style={{textAlign:"right" }}>
                            <input type="text" value={product.qty} onChange={(e) => this.qtyChange(product, e.target.value)} onBlur={(e) => this.qtyBlur(product, e.target.value)} placeholder="qty" style={{borderStyle:"none", padding:"6px", borderRadius:"6px", textAlign:"right", width:"69px", backgroundColor:"#efefef", color:"green"}} />
                          </TableCell>
                          <TableCell style={{textAlign:"right", paddingRight:"23px" }}>${Number(product.listPrice).toFixed(2)}</TableCell>
                          <TableCell style={{textAlign:"right", padding:"3px", fontWeight:600 }}>${product.total}</TableCell>
                          <TableCell style={{maxWidth:"54px", padding:"3px", textAlign:"center"}}>
                            <IconButton onClick={() => this.removeFromCart(product)}>
                              <Remove />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow key={"taxRow"}>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{textAlign:"right", paddingRight:"23px", fontWeight:"600"}}>Tax: </TableCell>
                        <TableCell style={{textAlign:"right", padding:"3px", fontWeight:"600"}}>${this.state.tax}</TableCell>
                        <TableCell style={{maxWidth:"54px", padding:"3px"}}></TableCell>
                      </TableRow>
                      <TableRow key={"totalRow"}>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{textAlign:"right", paddingRight:"23px", fontWeight:"600"}}>Total: </TableCell>
                        <TableCell style={{textAlign:"right", padding:"3px", fontWeight:"600"}}>${this.state.total}</TableCell>
                        <TableCell style={{maxWidth:"54px", padding:"3px"}}></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>

                  <GridContainer style={{marginBottom:"20px", marginTop:"50px"}}>
                    <GridItem xs={8} >
                      <CustomInput
                        labelText="Notes"
                        formControlProps={{
                          fullWidth: true,
                          className: classes.formControl
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Notes className={classes.icon} />
                            </InputAdornment>
                          ),
                          placeholder: "Anything else we should know?"
                        }}
                        value={this.state.notes}
                        onChange={this.notesChange}
                      />
                    </GridItem>
                    <GridItem xs={4} >
                      <Button color="warning" onClick={this.createQuote} disabled={this.props.isDisabled} style={{width:"100%"}} >
                        Create Quote and Save Order
                      </Button>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
              
              <Card style={{marginBottom:"100px"}}>
                <CardBody>
                  <GridContainer style={{marginTop:"17px"}}>
                    <GridItem xs={4} style={{fontSize:"13px", lineHeight:"15px", fontWeight:"400", marginTop:"19px", color:"#666666"}}>
                      If you already have an approved Purchase Order Number you can checkout now
                      and get started immediately.
                    </GridItem>
                    <GridItem xs={4} >
                      <CustomInput
                        labelText="Purchase Order #"
                        formControlProps={{
                          fullWidth: true,
                          className: classes.formControl
                        }}
                        inputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Receipt className={classes.icon} />
                            </InputAdornment>
                          ),
                          placeholder: "Purchase Order # (required)"
                        }}
                        value={this.state.poNumber}
                        onChange={this.poNumberChange}
                      />
                    </GridItem>
                    <GridItem xs={4} style={{textAlign:"right", marginTop:"10px"}}>
                      <Elements>
                        <Checkout cart={this.state.cart} 
                          shipTo={this.state.shipTo} 
                          shippingAddress={this.state.shipToAddress} 
                          tax={this.state.tax} 
                          poNumber={this.state.poNumber} 
                          notes={this.state.notes} 
                          schoolID={this.props.user.schoolID}
                          isDisabled={this.readyToCheckout()}
                        />
                      </Elements>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        </div>
        
        <Footer content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="https://app.allthingseq.com/"
                    className={classes.block}
                  >
                    All Things E.Q.
                  </a>
                </ListItem>
                
              </List>
            </div>
            <div className={classes.right} style={{fontSize:"12px", marginRight:"23px"}}>
              &copy; {1900 + new Date().getYear()}{" "}
              AVA School Solutions
            </div>
          </div>
          }/>
      </div>
      </StripeProvider>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onCartCleared: CartCleared, onCartProductRemoved: CartProductRemoved}, dispatch);  
}

ShoppingCartPage = connect(mapStateToProps, mapDispatchToProps)(ShoppingCartPage);
export default withStyles(shoppingCartStyle)(ShoppingCartPage);



// WEBPACK FOOTER //
// ./src/views/ShoppingCartPage/ShoppingCartPage.jsx